module.exports = __webpack_public_path__ + "img/Certificate_pic01.3a61ba94.png";